
export enum PartyShipmentRoleCd {
	ALL = 'All',
	BILL_TO = 'Bill-To',
	CONSIGNEE = 'Consignee',
	SHIPPER = 'Shipper'}
